module.exports = __webpack_public_path__ + "img/tcv_stopped.96cdeb4b.svg";